// extracted by mini-css-extract-plugin
export default {"DropImageZone":"ImageDropZone_DropImageZone__k4tB9"};